import Filter from "../modules/filter";

const TaxProductCat = {
  init() {
    Filter.init();
    TaxProductCat.toggleFilters();

    this.events();

    const btnEl = $(".toggle-more");
    this.seo(btnEl);
  },

  events() {
    $(".toggle-more").on("click", (e) => {
      const moreEl = $(".prod-cat-seo__more");
      let expanded = moreEl.attr("aria-expanded") === "true";
      expanded = !expanded;
      moreEl.attr("aria-expanded", expanded);

      const btnEl = $(e.currentTarget);
      TaxProductCat.seo(btnEl);
    });
  },

  seo(btnEl) {
    const moreEl = btnEl.siblings(".prod-cat-seo__more");
    const expanded = moreEl.attr("aria-expanded") === "true";

    let currStatus = expanded ? "less" : "more";

    btnEl.text(btnEl.data(currStatus));

    if (!expanded) {
      moreEl.slideUp(250);
    } else {
      moreEl.slideDown(250);
    }
  },

  toggleFilters() {
    const filterEl = $(".filters");
    const openBtn = $(".btn-open-filter");

    openBtn.on("click", function () {
      filterEl.addClass("open");
      openBtn.addClass("hidden");
      $("html").addClass("no-scroll");
    });

    filterEl.on("click", ".btn-close-filter", function () {
      filterEl.removeClass("open");
      openBtn.removeClass("hidden");
      $("html").removeClass("no-scroll");
    });
  },
};

export default TaxProductCat;
